import { render, staticRenderFns } from "./BFakeNotify.vue?vue&type=template&id=41dbc4a6&"
import script from "./BFakeNotify.vue?vue&type=script&lang=js&"
export * from "./BFakeNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QOptionGroup,QInput,QCardActions,QSpace});qInstall(component, 'directives', {ClosePopup});
